import './styles.css';

import clsx from 'clsx';
import Image from 'next/image';

import { ChevronRightIcon } from '@/shared';

import { Button } from '../../';
import type { ICTAStartLearn } from '../../types';

export const CTAStartLearn = ({
	title,
	description,
	buttonText,
	buttonHref,
	image,
	imagePosition = 'right',
	backgroundImage,
}: ICTAStartLearn) => {
	const backgroundStyle = backgroundImage
		? {
				backgroundImage: `url(${backgroundImage})`,
			}
		: {};

	const contentElement = (
		<div
			className={clsx({
				'md:order-1': image && imagePosition === 'right',
				'md:order-2': image && imagePosition === 'left',
			})}
		>
			<h2 className="cta-title">{title}</h2>

			{Array.isArray(description) ? (
				<ul className="list-outside list-disc space-y-2 pl-4 text-base/[1.35] opacity-70 lg:w-2/3 xl:pl-12 xl:text-2xl/[1.3]">
					{description.map((item, index) => (
						<li key={index}>{item}</li>
					))}
				</ul>
			) : (
				<p className="text-base/[1.35] opacity-70 lg:w-2/3 xl:text-2xl/[1.3]">
					{description}
				</p>
			)}

			<div className="mt-6 xl:mt-12">
				<Button
					href={buttonHref}
					variant="white"
					size="72"
					className="cta-action"
				>
					{buttonText}
					<ChevronRightIcon className="size-5" />
				</Button>
			</div>
		</div>
	);

	const imageElement = image && (
		<div
			className={clsx('h-full flex-shrink-0', {
				'md:order-2': imagePosition === 'right',
				'md:order-1': imagePosition === 'left',
			})}
		>
			<Image
				src={image.src}
				alt={image.alt}
				width={400}
				height={300}
				className="h-full w-full rounded-2xl object-cover xl:rounded-3xl 2xl:rounded-[60px]"
			/>
		</div>
	);

	return (
		<div
			className={clsx('cta cta-start-learn xl:items-center', {
				'with-background': backgroundImage,
				'flex flex-col justify-between gap-12 xl:flex-row': image,
			})}
			style={backgroundStyle}
		>
			{imagePosition === 'left' ? (
				<>
					{imageElement}
					{contentElement}
				</>
			) : (
				<>
					{contentElement}
					{imageElement}
				</>
			)}
		</div>
	);
};
